/* eslint-disable react/function-component-definition */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-restricted-properties */
/* eslint-disable no-plusplus */
import React, { useState, useEffect, useMemo, useCallback } from "react";
import axios from "axios";
import { isExpired, decodeToken } from "react-jwt";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import {
  useNavigate,
  useLocation,
  useMatch,
  Link,
  useParams,
} from "react-router-dom";
import BackArrow from "../assets/img/back-arrow.svg";
import ChevronLeft from "../assets/img/chevron-left.svg";
import ChevronRight from "../assets/img/chevron-right.svg";
import FolderCreate from "../assets/img/folder-add.svg";
import HowToIcon from "../assets/img/HowToIcon.svg";
import userPic from "../assets/img/user.svg";
import downloadIcon from "../assets/img/downloads/downloadIcon.svg";
import noFillHeartPic from "../assets/img/heart-no-fill.svg";
import signOutPic from "../assets/img/sign-out.svg";
import { getValues, sidebarItemProps } from "../utils/sidebar";
import {
  CatalogInterface,
  SideBarDataInfo,
  SideBarResponse,
} from "../models/interfaces/common";
import { useAppSelector, useAppDispatch } from "../store";
import http from "../services/api";
import { FavoriteFolder } from "./SidebarFavoriteFolders";
import ManageFavoriteModal from "./modals/ManageFavoriteModal";
import { setMainSideBarItems } from "../pages/sidebarSlice";
import SecureLS from "../utils/SecureStorage";
import { setUser, clearUser } from "../pages/auth/userSlice";
import { saveToken, setAuthState, clearToken } from "../pages/auth/authSlice";
import { removeAllFilters } from "../pages/filterSlice";
import { setCatalogs } from "../pages/catalogSlice";
import { getCatalogs } from "../utils/catalog";
import { scrollToTop } from "../util";
import { setAssetIdList } from "../pages/assetsSlice";
import { removeSelectedFilters } from "../pages/filterOptionsSlice";
import { removeProcesses } from "../pages/multipleAssetDownloadSlice";
import { initialState, setInPageNavState } from "./inPageNavSlice";

import { Modal } from "react-bootstrap";
import { ModalProps } from "@/types/common";
import SmallLoader from "./loaders/SmallLoader";
import RegionSelectionModal from "./modals/RegionSelectionModal";

interface SideBarHash {
  [details: string]: sidebarItemProps;
}

interface SidebarProps {
  isMobile: boolean;
  showMobileMenu: boolean;
  toggleHamburgerMenu: () => void;
}

interface MobileParentNavProps {
  onNavigate: (section: string) => void;
  currentSection: string;
  toggleHamburgerMenu: () => void;
  onRegionClick: () => void;
}

export default function Sidebar({
  isMobile,
  showMobileMenu,
  toggleHamburgerMenu,
}: SidebarProps) {
  const { t, i18n } = useTranslation("common");
  const dispatch = useAppDispatch();
  const [showManageFavorite, setShowManageFavorite] = useState(false);
  const [mobileCurrentSection, setMobileCurrentSection] = useState<string>("");
  const [showRegionModal, setShowRegionModal] = useState(false);
  const { accountPage } = useParams();
  const { howToPage } = useParams();
  const [selectedFolder, setSelectedFolder] = useState<string | null>(
    "My Favorites"
  );

  const primaryRegion = useAppSelector(
    (state) => state.user?.primaryRegion as string
  );

  const cancelToken = axios.CancelToken;
  const source = cancelToken.source();

  // const MainSideBarReference = [
  //   "Imagery",
  //   "Videos",
  //   "Logos & Guidelines",
  //   "Swatchcards & Catalogs",
  //   "Social Media",
  //   "Email Ads",
  //   "Web Banners",
  //   "Ads & Sell Sheets",
  //   "Posters & Signage",
  //   "Hangtags",
  // ];

  const [mainSideBarRender, setMainSideBarRender] = useState<
    sidebarItemProps[]
  >([]);
  const navigate = useNavigate();
  const location = useLocation();
  const isSharedPage = useMatch("/shared/:token");
  const isFavoritesPage = useMatch("/favorites");
  const isAccountPage = useMatch("/account/:accountPage");
  const isHowToPage = useMatch("/howto/:howToPage");
  const isDownloadsPage = useMatch("/downloads");
  const userId = useAppSelector((state) => state.user?.id) as string;
  const mainSideBar = useAppSelector((state) => state.sidebar.hash);
  const shareExpirationdate = useAppSelector(
    (state) => state.sidebar.shareExpirationdate
  );
  const catalogs = useAppSelector((state) => state.catalog.catalogs);
  const [cookies, setCookie, removeCookie] = useCookies([
    "rememberMeEmail",
    "rememberMePassword",
    "JSESSIONID",
    "sid",
    "ln",
    "srefresh",
    "enduser_version",
    "proximity_cc91527febee5e661206adb5f3f102b3",
    "okta-oauth-nonce",
    "t",
    "Okta_Verify_Autopush_978541678",
    "DT",
    "okta-oauth-state",
    "okta-oauth-redirect-params",
  ]);

  const OktaValidation = cookies["okta-oauth-state"] === undefined;

  const insertCatalogs = (value: CatalogInterface[]) =>
    dispatch(setCatalogs(value));

  const toggleManageFavoriteModal = () =>
    setShowManageFavorite(!showManageFavorite);

  const deleteRememberMeCookies = () => {
    removeCookie("rememberMeEmail");
    removeCookie("rememberMePassword");
  };

  const deleteOktaCookies = () => {
    removeCookie("JSESSIONID");
    removeCookie("sid");
    removeCookie("ln");
    removeCookie("srefresh");
    removeCookie("enduser_version");
    removeCookie("proximity_cc91527febee5e661206adb5f3f102b3");
    removeCookie("okta-oauth-nonce");
    removeCookie("t");
    removeCookie("Okta_Verify_Autopush_978541678");
    removeCookie("DT");
    removeCookie("okta-oauth-state");
    removeCookie("okta-oauth-redirect-params");
  };

  const clearAllCookies = () => {
    document.cookie =
      "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  };

  const handleLogout = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();
    deleteRememberMeCookies();
    deleteOktaCookies();
    SecureLS.removeItem("user");
    SecureLS.removeItem("okta-cache-storage");
    SecureLS.removeItem("okta-token-storage");
    clearAllCookies();
    dispatch(removeProcesses());
    // Clear Redux state
    dispatch(clearToken());
    dispatch(setAuthState(false));
    dispatch(clearUser());
  };

  const apiCall = useCallback(
    (regionId: string, isCancelled: (arg0: any) => boolean) => {
      const path = "/api/categories";

      if (userId) {
        http
          .post<SideBarResponse>(path, {
            // cancelToken: source.token,
            regionId,
            userId,
          })
          .then((res) => {
            const response = res
              ? (res?.data as unknown as SideBarDataInfo[])
              : [];
            const hashTemp: SideBarHash = {};
            for (let i = 0; i < response.length; i++) {
              const itemValues = getValues(response[i].brandPortalCategoryName);
              const temp: sidebarItemProps = {
                text: response[i].brandPortalCategoryName,
                count: Number(response[i].assetsCount),
                path: itemValues ? itemValues.path : "",
                size: response[i].categoryAssetsSize / 1024 ** 3,
              };
              if (!hashTemp[temp.text]) hashTemp[temp.text] = temp;
            }
            dispatch(setMainSideBarItems(hashTemp));
          })
          .catch((error) => {
            // console.log("error", error);
          });
      }
    },
    [userId]
  );

  useEffect(() => {
    if (!(catalogs.length > 0)) getCatalogs(insertCatalogs, source);

    return () => {
      source.cancel("");
    };
  }, []);

  useEffect(() => {
    const folderName = new URLSearchParams(location.search).get(
      "favoriteFolder"
    );
    if (folderName) setSelectedFolder(decodeURIComponent(folderName));
  });

  useEffect(() => {
    const secureData = SecureLS.getItem("user")
      ? JSON.parse(SecureLS.getItem("user"))
      : {};
    if (secureData?.data) dispatch(setUser(secureData.data));
    if (secureData?.token) {
      dispatch(saveToken(secureData.token));
      dispatch(setAuthState(true));
    }
  }, []);

  // Reset mobile navigation when sidebar is closed
  useEffect(() => {
    if (!showMobileMenu && isMobile) {
      setMobileCurrentSection("");
    }
  }, [showMobileMenu, isMobile]);

  useEffect(() => {
    const tempArray: sidebarItemProps[] = [];
    for (let i = 0; i < catalogs.length; i++) {
      if (mainSideBar) tempArray.push(mainSideBar[catalogs[i].catalog]);
    }
    setMainSideBarRender([...tempArray]);
  }, [mainSideBar, catalogs]);

  useEffect(() => {
    const secureLS = SecureLS.getItem("user");
    const dataValue = secureLS ? JSON.parse(secureLS) : null;
    if (dataValue)
      apiCall(primaryRegion, (value: any) => axios.isCancel(value));

    return () => {
      source.cancel("Component was destroyed and unmounted!!!");
    };
  }, [primaryRegion, userId]);

  interface BrandValues {
    node: SampleNode;
  }

  interface SampleNode {
    id: number;
    name: string;
  }

  const removeFilters = () => dispatch(removeAllFilters());
  const removeActiveFilters = () => dispatch(removeSelectedFilters());
  const setAssetIds = (ids: string[]) => dispatch(setAssetIdList(ids));

  // Mobile navigation handlers
  const handleMobileNavigation = (section: string) => {
    setMobileCurrentSection(section);
  };

  const handleMobileBack = () => {
    setMobileCurrentSection("");
  };

  // Region modal handlers
  const handleRegionModalOpen = () => {
    setShowRegionModal(true);
    toggleHamburgerMenu();
  };

  const toggleRegionModal = () => {
    setShowRegionModal(!showRegionModal);
  };

  const MobileParentNav = React.memo(
    ({
      onNavigate,
      currentSection,
      toggleHamburgerMenu,
      onRegionClick,
    }: MobileParentNavProps) => {
      const currentPage = location.pathname;
      return (
        <>
          <div className="mobile-sidebar-header d-flex justify-content-end align-items-center mb-3">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={toggleHamburgerMenu}
            />
          </div>
          <div className="d-block">
            <hr />
          </div>
          <ul className="category-nav">
            <li>
              <a
                className={`category-link ${currentPage.includes("/catalog") ? "active" : ""}`}
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  onNavigate("library");
                }}
              >
                <div className="text">{t("Asset Library")}</div>
                <img
                  className="me-2"
                  src={ChevronRight}
                  alt="Asset Library"
                  width="10"
                />
              </a>
            </li>
            <li>
              <a
                className={`category-link ${currentPage.includes("/howto") ? "active" : ""}`}
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  onNavigate("howto");
                }}
              >
                <div className="text">{t("How-To")}</div>
                <img
                  className="me-2"
                  src={ChevronRight}
                  alt="How-To"
                  width="10"
                />
              </a>
            </li>
            <li>
              <a
                className={`category-link ${currentPage.includes("/account") ? "active" : ""}`}
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  onNavigate("account");
                }}
              >
                <div className="text">{t("My Account")}</div>
                <img
                  className="me-2"
                  src={ChevronRight}
                  alt="My Account"
                  width="10"
                />
              </a>
            </li>
            <li>
              <a
                className="category-link"
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  onRegionClick();
                }}
              >
                <div className="text">{t("Region")}</div>
                <img
                  className="me-2"
                  src={ChevronRight}
                  alt="Region"
                  width="10"
                />
              </a>
            </li>
            <li>
              <a
                className={`category-link ${currentPage.includes("/downloads") ? "active" : ""}`}
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  onNavigate("downloads");
                  navigate("/downloads");
                  toggleHamburgerMenu();
                }}
              >
                <div className="text">{t("Downloads")}</div>
                <img
                  className="me-2"
                  src={ChevronRight}
                  alt="Downloads"
                  width="10"
                />
              </a>
            </li>
            <li>
              <a
                className={`category-link ${currentPage.includes("/favorites") ? "active" : ""}`}
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  onNavigate("favorites");
                }}
              >
                <div className="text">{t("Favorites")}</div>
                <img
                  className="me-2"
                  src={ChevronRight}
                  alt="Favorites"
                  width="10"
                />
              </a>
            </li>
            <li>
              <a
                className="category-link"
                href="/login"
                onClick={(event) => {
                  handleLogout(event);
                }}
              >
                <div className="text">{t("Logout")}</div>
                <img
                  className="me-2"
                  src={signOutPic}
                  alt="Logout"
                  width="20"
                />
              </a>
            </li>
          </ul>
        </>
      );
    }
  );

  const MainDashboardSidebarItems = React.memo(() => (
    <>
      {mainSideBarRender.map((sidebaritem) =>
        sidebaritem?.count > 0 ? (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
          <li
            key={`${sidebaritem?.text}-${sidebaritem?.count}-${sidebaritem?.path}`}
            onClick={() => {
              removeFilters();
              removeActiveFilters();
              setAssetIds([]);
            }}
          >
            <Link
              to={sidebaritem?.path}
              className={`category-link ${
                location.pathname === sidebaritem?.path ? "active" : ""
              }`}
              onClick={() => {
                scrollToTop();
                if (isMobile) toggleHamburgerMenu();
              }}
            >
              <div className="text">{t(sidebaritem?.text)}</div>
              <div className="pill">{sidebaritem?.count}</div>
            </Link>
          </li>
        ) : null
      )}
    </>
  ));

  const FavoriteSidebarContent = React.memo(() => (
    <>
      {isMobile ? (
        <div className="mobile-sidebar-header d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex justify-content-start justify-content-md-between align-items-center">
            <a
              className="library-return-link-mobile"
              href="#"
              onClick={(event) => {
                event.preventDefault();
                if (mobileCurrentSection) {
                  handleMobileBack();
                } else {
                  navigate("/");
                }
              }}
            >
              <img
                className="me-2"
                src={ChevronLeft}
                alt="Return to Asset Library"
              />
            </a>
            <h2 className="mb-0">{t("Favorites")}</h2>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={toggleHamburgerMenu}
          />
        </div>
      ) : (
        <>
          <a
            className="library-return-link"
            href="#"
            onClick={(event) => {
              event.preventDefault();
              navigate("/");
              dispatch(removeProcesses());
            }}
          >
            <img
              className="me-2"
              src={BackArrow}
              alt="Return to Asset Library"
            />
            {t("Return to Asset Library")}
          </a>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="mb-0">{t("Favorites")}</h2>
            <a
              className="Folder-create"
              href="#"
              onClick={(event) => {
                event.preventDefault();
                toggleManageFavoriteModal();
              }}
            >
              <img src={FolderCreate} alt="Create Folder" />
            </a>
          </div>
        </>
      )}

      <div className="d-block">
        <hr />
      </div>

      <ul className="category-nav">
        {isMobile && (
          <a
            className="create-folder"
            href="#"
            onClick={(event) => {
              event.preventDefault();
              toggleManageFavoriteModal();
            }}
          >
            <img src={FolderCreate} alt="Create a Folder" />
            <div className="text">{t("Create A Folder")}</div>
          </a>
        )}
        <FavoriteFolder
          selectedFolder={selectedFolder}
          toggleHamburgerMenu={isMobile ? toggleHamburgerMenu : () => {}}
        />
      </ul>
    </>
  ));

  const SharedSidebarContent = React.memo(() => {
    const [expirationDate, setExpirationDate] = useState<string>("");
    const secureLS = SecureLS.getItem("user");
    const dataValue = secureLS ? JSON.parse(secureLS) : null;

    useEffect(() => {
      const mydate = new Date(shareExpirationdate as string);
      const month = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ][mydate.getMonth()];

      setExpirationDate(
        month && mydate
          ? `${month} ${
              shareExpirationdate
                ? (shareExpirationdate as string).split("-")[2]
                : ""
            }, ${mydate.getFullYear()}`
          : ""
      );
    }, []);

    return (
      <>
        {isMobile ? (
          <div className="mobile-sidebar-header d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex justify-content-start justify-content-md-between align-items-center">
              {(dataValue || !isExpired(dataValue?.token)) && (
                <a
                  className="library-return-link-mobile"
                  href="#"
                  onClick={(event) => {
                    event.preventDefault();
                    if (mobileCurrentSection) {
                      handleMobileBack();
                    } else {
                      navigate("/");
                    }
                  }}
                >
                  <img
                    className="me-2"
                    src={ChevronLeft}
                    alt="Return to Asset Library"
                  />
                </a>
              )}
              <h2>{t("Shared Items")}</h2>
            </div>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={toggleHamburgerMenu}
            />
          </div>
        ) : (
          <>
            {(dataValue || !isExpired(dataValue?.token)) && (
              <a
                className="library-return-link"
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  navigate("/");
                }}
              >
                <img
                  className="me-2"
                  src={BackArrow}
                  alt="Return to Asset Library"
                />
                {t("Return to Asset Library")}
              </a>
            )}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2>{t("Shared Items")}</h2>
            </div>
          </>
        )}

        <div className="d-block">
          <hr />
        </div>
        <div className="files-shared">
          <p>{`${t("These files are shared until")} ${expirationDate}`}</p>
        </div>
      </>
    );
  });

  const UserSidebarContent = React.memo(() => (
    <>
      {isMobile ? (
        <div className="mobile-sidebar-header d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex justify-content-start align-items-center">
            <a
              className="library-return-link-mobile"
              href="#"
              onClick={(event) => {
                event.preventDefault();
                if (mobileCurrentSection) {
                  handleMobileBack();
                } else {
                  navigate("/");
                }
              }}
            >
              <img
                className="me-2"
                src={ChevronLeft}
                alt="Return to Asset Library"
              />
            </a>
            <h2 className="mb-0">{t("My Account")}</h2>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={toggleHamburgerMenu}
          />
        </div>
      ) : (
        <>
          <a
            className="library-return-link"
            href="#"
            onClick={(event) => {
              event.preventDefault();
              navigate("/");
              dispatch(removeProcesses());
            }}
          >
            <img
              className="me-2"
              src={BackArrow}
              alt="Return to Asset Library"
            />
            {t("Return to Asset Library")}
          </a>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="mb-0">{t("My Account")}</h2>
          </div>
        </>
      )}
      <div className="d-block">
        <hr />
      </div>

      <ul className="category-nav">
        {OktaValidation && (
          <li>
            <Link
              to="/account/profile"
              className={`category-link ${
                accountPage === "profile" ? "active" : ""
              }`}
              onClick={() => {
                scrollToTop();
                if (isMobile) toggleHamburgerMenu();
              }}
            >
              <div className="text">{t("User Profile")}</div>
            </Link>
          </li>
        )}
        <li>
          <Link
            to="/account/company"
            className={`category-link ${
              accountPage === "company" ? "active" : ""
            }`}
            onClick={() => {
              scrollToTop();
              if (isMobile) toggleHamburgerMenu();
            }}
          >
            <div className="text">{t("Company Information")}</div>
          </Link>
        </li>
        <li>
          <Link
            to="/account/region"
            className={`category-link ${
              accountPage === "region" ? "active" : ""
            }`}
            onClick={() => {
              scrollToTop();
              if (isMobile) toggleHamburgerMenu();
            }}
          >
            <div className="text">{t("Region Selection & Time")}</div>
          </Link>
        </li>
        <li>
          <Link
            to="/account/terms"
            className={`category-link ${
              accountPage === "terms" ? "active" : ""
            }`}
            onClick={() => {
              scrollToTop();
              if (isMobile) toggleHamburgerMenu();
            }}
          >
            <div className="text">{t("Terms and Conditions")}</div>
          </Link>
        </li>
      </ul>
    </>
  ));

  const HowToSidebarContent = React.memo(() => {
    const secureLS = SecureLS.getItem("user");
    const dataValue = secureLS ? JSON.parse(secureLS) : null;
    return (
      <>
        {isMobile ? (
          <div className="mobile-sidebar-header d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex justify-content-start align-items-center">
              {(dataValue || !isExpired(dataValue?.token)) && (
                <a
                  className="library-return-link-mobile"
                  href="#"
                  onClick={(event) => {
                    event.preventDefault();
                    if (mobileCurrentSection) {
                      handleMobileBack();
                    } else {
                      navigate("/");
                    }
                  }}
                >
                  <img
                    className="me-2"
                    src={ChevronLeft}
                    alt="Return to Asset Library"
                  />
                </a>
              )}
              <h2 className="mb-0">{t("HowTo")}</h2>
            </div>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={toggleHamburgerMenu}
            />
          </div>
        ) : (
          <>
            {(dataValue || !isExpired(dataValue?.token)) && (
              <a
                className="library-return-link"
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  navigate("/");
                }}
              >
                <img
                  className="me-2"
                  src={BackArrow}
                  alt="Return to Asset Library"
                />
                {t("Return to Asset Library")}
              </a>
            )}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="mb-0">{t("HowTo")}</h2>
            </div>
          </>
        )}
        <div className="d-block">
          <hr />
        </div>

        <ul className="category-nav">
          <li>
            <Link
              to="/howto/register"
              className={`category-link ${
                howToPage === "register" ? "active" : ""
              }`}
              onClick={() => {
                scrollToTop();
                if (isMobile) toggleHamburgerMenu();
              }}
            >
              <div className="text">{t("Register")}</div>
            </Link>
          </li>
          <li>
            <Link
              to="/howto/search"
              className={`category-link ${
                howToPage === "search" ? "active" : ""
              }`}
              onClick={() => {
                scrollToTop();
                if (isMobile) toggleHamburgerMenu();
              }}
            >
              <div className="text">{t("Search")}</div>
            </Link>
          </li>
          <li>
            <Link
              to="/howto/favorites"
              className={`category-link ${
                howToPage === "favorites" ? "active" : ""
              }`}
              onClick={() => {
                scrollToTop();
                if (isMobile) toggleHamburgerMenu();
              }}
            >
              <div className="text">{t("Add Favorites")}</div>
            </Link>
          </li>
          <li>
            <Link
              to="/howto/download"
              className={`category-link ${
                howToPage === "download" ? "active" : ""
              }`}
              onClick={() => {
                scrollToTop();
                if (isMobile) toggleHamburgerMenu();
              }}
            >
              <div className="text">{t("Download")}</div>
            </Link>
          </li>
          <li>
            <Link
              to="/howto/editDownload"
              className={`category-link ${
                howToPage === "editDownload" ? "active" : ""
              }`}
              onClick={() => {
                scrollToTop();
                if (isMobile) toggleHamburgerMenu();
              }}
            >
              <div className="text">{t("Edit Download Presets")}</div>
            </Link>
          </li>
          <li>
            <Link
              to="/howto/share"
              className={`category-link ${
                howToPage === "share" ? "active" : ""
              }`}
              onClick={() => {
                scrollToTop();
                if (isMobile) toggleHamburgerMenu();
              }}
            >
              <div className="text">{t("Share")}</div>
            </Link>
          </li>
          <li>
            <Link
              to="/howto/resetPassword"
              className={`category-link ${
                howToPage === "resetPassword" ? "active" : ""
              }`}
              onClick={() => {
                scrollToTop();
                if (isMobile) toggleHamburgerMenu();
              }}
            >
              <div className="text">{t("Reset Password")}</div>
            </Link>
          </li>
        </ul>
      </>
    );
  });

  const DownloadsSidebarContent = React.memo(() => (
    <>
      {isMobile ? (
        <div className="mobile-sidebar-header d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex justify-content-start justify-content-md-between align-items-center">
            <a
              className="library-return-link-mobile"
              href="#"
              onClick={(event) => {
                event.preventDefault();
                if (mobileCurrentSection) {
                  handleMobileBack();
                } else {
                  navigate("/");
                }
              }}
            >
              <img
                className="me-2"
                src={ChevronLeft}
                alt="Return to Asset Library"
              />
            </a>
            <h2 className="mb-0">{t("Downloads")}</h2>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={toggleHamburgerMenu}
          />
        </div>
      ) : (
        <>
          <a
            className="library-return-link"
            href="#"
            onClick={(event) => {
              event.preventDefault();
              navigate("/");
              dispatch(removeProcesses());
            }}
          >
            <img
              className="me-2"
              src={BackArrow}
              alt="Return to Asset Library"
            />
            {t("Return to Asset Library")}
          </a>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="mb-0">{t("Downloads")}</h2>
          </div>
        </>
      )}

      <div className="d-block">
        <hr />
      </div>
    </>
  ));

  const MainDashboardSidebar = () => (
    <>
      {isMobile ? (
        <div className="mobile-sidebar-header d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex justify-content-start justify-content-md-between align-items-center">
            <a
              className="library-return-link-mobile"
              href="#"
              onClick={(event) => {
                event.preventDefault();
                if (mobileCurrentSection) {
                  handleMobileBack();
                } else {
                  navigate("/");
                }
              }}
            >
              <img
                className="me-2"
                src={ChevronLeft}
                alt="Return to Asset Library"
              />
            </a>
            <h2 className="mb-0">{t("Asset Library")}</h2>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={toggleHamburgerMenu}
          />
        </div>
      ) : (
        <h2>{t("Asset Library")}</h2>
      )}
      <div>
        <hr />
      </div>
      {mainSideBarRender.length === 0 ? (
        <SmallLoader />
      ) : (
        <ul className="category-nav">
          <MainDashboardSidebarItems />
        </ul>
      )}
    </>
  );

  const SidebarContent = () => {
    // For mobile, show parent navigation first if no section is selected
    if (isMobile && !mobileCurrentSection) {
      return (
        <MobileParentNav
          onNavigate={handleMobileNavigation}
          currentSection={mobileCurrentSection}
          toggleHamburgerMenu={toggleHamburgerMenu}
          onRegionClick={handleRegionModalOpen}
        />
      );
    }

    // For mobile with selected section, show the appropriate content
    if (isMobile && mobileCurrentSection) {
      switch (mobileCurrentSection) {
        case "library":
          return <MainDashboardSidebar />;
        case "howto":
          return <HowToSidebarContent />;
        case "account":
          return <UserSidebarContent />;
        case "downloads":
          return <DownloadsSidebarContent />;
        case "favorites":
          return <FavoriteSidebarContent />;
        default:
          return <MainDashboardSidebar />;
      }
    }

    // For desktop, use the existing logic
    if (isFavoritesPage) {
      return <FavoriteSidebarContent />;
    }
    if (isSharedPage) {
      return <SharedSidebarContent />;
    }
    if (isAccountPage) {
      return <UserSidebarContent />;
    }
    if (isHowToPage) {
      return <HowToSidebarContent />;
    }
    if (isDownloadsPage) {
      return <DownloadsSidebarContent />;
    }
    return <MainDashboardSidebar />;
  };

  return (
    <>
      {!isMobile && (
        <aside className="left-col col-xl-3 col-lg-4 col-12">
          <SidebarContent />
        </aside>
      )}
      <ManageFavoriteModal
        isOpen={showManageFavorite}
        toggle={toggleManageFavoriteModal}
        modalClass="favoritesModal"
        centered
        backdrop="static"
        keyboard
        isAddToFavorite={false}
      />
      <RegionSelectionModal
        isOpen={showRegionModal}
        toggle={toggleRegionModal}
        modalClass="region-modal"
        centered
        backdrop="static"
        keyboard
      />
      <Modal
        show={showMobileMenu}
        onHide={toggleHamburgerMenu}
        backdrop={true}
        className="sidebar-modal"
        keyboard
      >
        <SidebarContent />
      </Modal>
    </>
  );
}
